import type { MemberRole } from "@nabble/sdk";

/** The two base roles every organization has; anyone may also hold custom roles (docs/adr/0022). */
export const ADMIN_ROLE_ID = "00000000-0000-0000-0000-000000000001";
export const COLLABORATOR_ROLE_ID = "00000000-0000-0000-0000-000000000002";

/** The roles a person gets in an organization unless someone picks others. */
export const DEFAULT_ROLE_IDS: readonly string[] = [COLLABORATOR_ROLE_ID];

/** A role offered in a role picker. `assignable: false` shows it but doesn't let it change. */
export interface PickableRole {
  id: string;
  name: string;
  description: string;
  system: boolean;
  assignable?: boolean;
}

/** The roles' names, comma-separated ("Administrator, Accounting"). */
export function roleNames(roles: MemberRole[]): string {
  return roles.map((r) => r.name).join(", ");
}

/** Base roles first, then the rest by name. */
export function sortRoles<R extends PickableRole>(roles: R[]): R[] {
  return [...roles].sort((a, b) => Number(b.system) - Number(a.system) || a.name.localeCompare(b.name));
}
